import script from "./Dialing.vue?vue&type=script&setup=true&lang=ts"
export * from "./Dialing.vue?vue&type=script&setup=true&lang=ts"

import "./Dialing.vue?vue&type=style&index=0&id=c29a9a48&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c29a9a48"]])

export default __exports__